// ⬇️ existing imports same
import React, { useMemo } from "react";
export default function ImageUploadBox({
  id,
  value = null,
  onChange,
  baseURL = "",
  accept = "image/*",
  required = false,

  variant = "dashed",
  height = 160,
  fit = "cover",

  label = "Image",              // 🔥 label used in overlay
  addText = "Upload",
  updateText = "Update",
  changeText = "Change",
  isEdit = false,

  icon = "fa-solid fa-cloud-arrow-up",
  overlayText,                  // optional manual override
}) {
  const previewSrc = useMemo(() => {
    if (!value) return "";
    if (typeof value === "string") return `${baseURL}/uploads/${value}`;
    return URL.createObjectURL(value);
  }, [value, baseURL]);

  // ✅ FINAL overlay text logic
  let actionText;
  if (overlayText) {
    actionText = overlayText;
  } else if (previewSrc) {
    actionText = `${changeText} ${label}`;
  } else if (isEdit) {
    actionText = `${updateText} ${label}`;
  } else {
    actionText = `${addText} ${label}`;
  }

  return (
    <div className={`iu2-wrap ${variant}`}>
      <input
        type="file"
        id={id}
        className="iu2-input"
        accept={accept}
        onChange={onChange}
        required={required}
      />

      <label htmlFor={id} className="iu2-card" style={{ height }}>
        {previewSrc ? (
          <img
            src={previewSrc}
            alt={label}
            className="iu2-img"
            style={{ objectFit: fit }}
          />
        ) : (
          <div className="iu2-empty">
            <div className="iu2-emptyIcon">
              <i className={icon}></i>
            </div>
            <div className="iu2-emptyLabel">{label}</div>
            <div className="iu2-emptyHint">click here to upload</div>
          </div>
        )}

        <div className="iu2-overlay">
          <div className="iu2-overlayInner">
            <i className={icon}></i>
            <span>{actionText}</span>
          </div>
        </div>
      </label>
    </div>
  );
}
